import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const customerApi = apiResourceBuilder({
  name: 'cuss/2.0/individuals',
  idResolver: ({ key }) => key,
});

export const CustomerSchema = new schema.Entity(
  'customers',
  {},
  { idAttribute: 'key' }
);
export default entityActionCreator({
  schema: CustomerSchema,
  api: customerApi,
});



// WEBPACK FOOTER //
// ./src/App/account/actions/customers/index.js